import React, { Component } from "react";
import { Route } from "react-router-dom";

const GenericLayout = ({ children }) => <>{children}</>;

const GenericLayoutRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(matchProps) => (
        <GenericLayout>
          <Component {...matchProps} />
        </GenericLayout>
      )}
    />
  );
};

export default GenericLayoutRoute;
